import { Button, ButtonVariant } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { removeCurrencySymbols } from '@egw/utils'
import { type FC } from 'react'
import { useTransferContextProvider } from '../../context'
import { SettlementAlert } from '../settlement-alert/settlement-alert'
import { TransferTermsAndConditions } from '../transfer-terms-conditions/transfer-terms-conditions'

export const SubmitTransferButton: FC = () => {
  const { t } = useTranslation('features-transfer')

  const {
    amountFieldValue,
    isFormValid,
    submitForm,
    achOrderIsLoading,
    bankInvestmentTransferLoading,
    internalBankTransferLoading,
    investmentAchTransferLoading,
  } = useTransferContextProvider()

  // Amount Field is Greater than 0 than show the Submit Transfer Button
  const showTransferButton = Boolean(amountFieldValue) && removeCurrencySymbols(String(amountFieldValue ?? '')) > 0

  const onClick = async (): Promise<void> => {
    await submitForm().catch((e: unknown) => {
      // eslint-disable-next-line no-console
      console.error(e)
    })
  }

  return (
    showTransferButton && (
      <>
        {/* Alert to show when moving money from Personal Portfolio */}
        <SettlementAlert />
        <TransferTermsAndConditions />
        <Button
          variant={ButtonVariant.Primary}
          id="submitTransfer_primary_btn"
          testId="submitTransfer_primary_btn"
          loadingContent={t('transfer.transferring')}
          className="mb-4 md:w-fit"
          isDisabled={!isFormValid}
          onClick={() => {
            void onClick()
          }}
          isLoading={
            achOrderIsLoading ||
            bankInvestmentTransferLoading ||
            internalBankTransferLoading ||
            investmentAchTransferLoading
          }
        >
          {t('transfer.transfer')}
        </Button>
      </>
    )
  )
}
